module.exports = __webpack_public_path__ + "media/images/lp-phone-2b6e8666e937caeb7b085b2199172d96.png";